import { render, staticRenderFns } from "./page-content.vue?vue&type=template&id=3449c8cc"
import script from "./page-content.ts?vue&type=script&lang=ts&external"
export * from "./page-content.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports